import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../../../libs/styled.es.js';

const ModalBody = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(Wrapper, Object.assign({}, props), children);
};
const Wrapper = styled.div `
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`;

export { ModalBody };
